// What the server says about a registration fee credit on a single-invoice save (#374 /qa M2, M3):
// what went on, what was asked for and did not, and when the credit step itself failed (the invoice
// stands without it). Used by the Edit and Create-from-weeks hooks so a credit that did not go on is
// never silent.

export interface RegistrationCreditOutcome {
  applied: Array<{ studentId: string; amount: string; calculatedAmount: string }>;
  skipped: Array<{ studentId: string; studentName?: string; reason: string }>;
  failed?: { message: string };
}

const REASON_TEXT: Record<string, string> = {
  ALREADY_CREDITED: 'already credited on another invoice',
  NO_TUITION: 'no tuition on this invoice',
  NOT_HELD: 'no longer held',
  NOT_ON_INVOICE: 'not billed on this invoice',
  NOTHING_LEFT: 'nothing left to credit after the discounts',
};

export function skippedReasonText(reason: string): string {
  return REASON_TEXT[reason] ?? reason.toLowerCase().replace(/_/g, ' ');
}

/** A warning for the office, or null when there is nothing to say. */
export function creditOutcomeWarning(outcome: RegistrationCreditOutcome | undefined | null): string | null {
  if (!outcome) return null;
  if (outcome.failed) {
    return `The invoice was saved, but its registration fee credit could not be applied (${outcome.failed.message}). The fee is still held: add it in Edit, or find it on the "Registration fees not yet applied" report.`;
  }
  if (outcome.skipped.length === 0) return null;
  const who = outcome.skipped.map((s) => `${s.studentName ?? 'A child'} (${skippedReasonText(s.reason)})`).join(', ');
  return `Registration fee credit not applied: ${who}. The fee stays held.`;
}
